import React, { Component } from 'react';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import LogoBG from '../../Asset/app/media/img//bg/bg-1.jpg';
import axios from 'axios';
import { Link } from 'react-router-dom';
import 'reactjs-popup/dist/index.css';
import queryString from 'query-string';
import moment, { invalid } from 'moment'
import global from '../global'
import { Card, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import Spinner from '../Spinner';
import { config } from '../../Constants';

export class UserProfile extends Component {
    displayName = UserProfile.name

    constructor(props) {
        super(props);
        this.state = {
            beneficiaryID: 0,
            remitterID: 0,
            userName: '',
            beneficiaryName: '',
            fullName: '',
            PAN: '',
            DPID: '',
            URL: '',
            remitterName: '',
            DOB: moment().format('YYYY-MM-DD'),
            dividentDeclarationDate: Date,
            password: '',
            ConfirmPassword: '',
            EmailId: '',
            formErrors: '',
            remitterCode: '',
            loading: false,
            currentDate: '2021-04-28',
            Title: 'CREATE PROFILE',
            ButtonText: 'CREATE',
            IsDOBEnable: false,
            Type: 'N'
        };
        this.initialState = this.state;

        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        remitterCode: response.data.RemitterCode,
                        URL: config.url.Web_URL + '/' + response.data.RemitterCode
                    });
                } else {
                    window.location.href = config.url.Web_URL + `/Error/404`;
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });

        const parsed = queryString.parse(window.location.search);
        this.state.PAN = window.atob(parsed['bD']);
        this.state.remitterID = window.atob(parsed['rD']);

        var ReqType = window.atob(parsed['ReqType']);
        this.state.Type = ReqType;

        if (ReqType == "F") {
            this.state.Title = "UPDATE PROFILE"
            this.state.ButtonText = "UPDATE"
            this.state.IsDOBEnable = true
        }
        else {
            this.state.Title = "CREATE PROFILE"
            this.state.ButtonText = "CREATE"
            this.state.IsDOBEnable = false
        }

        this.state.currentDate = moment().format("YYYY-MM-DD");

        if (this.state.PAN != "" || this.state.PAN != null) {
            axios.get(global.UserManagement.GetUserProfileAPI + this.state.PAN + '&remitterID=' + this.state.remitterID).then(response => {
                this.setState({
                    beneficiaryName: response.data.beneficiaryDetails[0]["UserName"],
                    remitterName: response.data.beneficiaryDetails[0]["RemitterName"],
                    EmailId: response.data.beneficiaryDetails[0]["EmailID"],
                    PAN: response.data.beneficiaryDetails[0]["PAN"],
                    DOB: moment(response.data.beneficiaryDetails[0]["DOB"]).format('YYYY-MM-DD') === null ? " " : moment(response.data.beneficiaryDetails[0]["DOB"]).format('YYYY-MM-DD')

                })
            })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            this.showNoti("Notification", "Something Went Wrong. Kindly Try Again.", "danger");
            return;
        }
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    handleFormValidation = (e) => {
        const { beneficiaryName, DPID, password, DOB, ConfirmPassword } = this.state;
        let formErrors = {};
        let formIsValid = true;

        if (!ConfirmPassword) {
            formIsValid = false;
            formErrors["passwordErr"] = "Confirm Password is required.";
        }

        if (!password) {
            formIsValid = false;
            formErrors["passwordErr"] = "Password is required.";
        }
        else if (!(/^ (?=.*\d) (?=.* [!@#$%^&*]) (?=.* [a - z])(?=.* [A - Z]).{ 8,} $/.test(password))) {
            if (password.length < 8) {
                formIsValid = false;
                formErrors["passwordErr"] = "Your password must contain at least 8 characters";
            } else if (!(/[0-9]/.test(password))) {
                formIsValid = false;
                formErrors["passwordErr"] = "Your password must contain at least one digit.";
            }
            else if (!(/([!@#$%^&*])/.test(password))) {
                formIsValid = false;
                formErrors["passwordErr"] = "Your password must contain at least one special character.";
            }
            else if (!(/[A-Z]/.test(password))) {
                formIsValid = false;
                formErrors["passwordErr"] = "Your password must contain at least one upper case letter.";
            }
            else if (password != ConfirmPassword) {
                formIsValid = false;
                formErrors["passwordErr"] = "Password and Confirm Password Should Match.";
            }

        }

        //beneficiaryName
        if (!beneficiaryName) {
            formIsValid = false;
            formErrors["beneficiaryNameErr"] = "Beneficiary Name is required.";
        }

        //DOB    
        if (!DOB) {
            formIsValid = false;
            formErrors["DOBErr"] = "Date of Birth is required.";
        }
        //Email    
        if (!DPID) {
            formIsValid = false;
            formErrors["DPIDErr"] = "DPID is required.";
        }

        this.setState({ formErrors: formErrors });
        const { name, value } = e.target;
        this.setState({ [name]: value });
        return formIsValid;
    }


    handleCancel(e) {
        e.preventDefault();
        window.location.href = this.state.URL;
    }
    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handlePANChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value.toUpperCase() });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ loading: true });

        if (this.state.DOB == 'Invalid date') {
            this.setState({ loading: false });
            this.showNoti("Notification", "DOB is Required", "danger");
            return;
        }

        if (this.state.DOB == '') {
            this.setState({ loading: false });
            this.showNoti("Notification", "DOB is Required", "danger");
            return;
        }

        if (this.state.password == '') {
            this.setState({ loading: false });
            this.showNoti("Notification", "Password mandatory to create user profile", "danger");
            return;
        }

        if (this.state.ConfirmPassword == '') {
            this.setState({ loading: false });
            this.showNoti("Notification", "Password mandatory to create user profile", "danger");
            return;
        }

        if (this.state.password != this.state.ConfirmPassword) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Password and confirm password did not match", "danger");
            return;
        }

        if (!(/^ (?=.*\d) (?=.* [!@#$%^&*]) (?=.* [a - z])(?=.* [A - Z]).{ 8,} $/.test(this.state.password))) {
            if (this.state.password.length < 8) {
                this.setState({ loading: false });
                this.showNoti("Notification", "Your password must contain at least 8 characters.", "danger");
                return;
            }
            else if (!(/[0-9]/.test(this.state.password))) {
                this.setState({ loading: false });
                this.showNoti("Notification", "Your password must contain at least one digit.", "danger");
                return;
            }
            else if (!(/([!@#$%^&*])/.test(this.state.password))) {
                this.setState({ loading: false });
                this.showNoti("Notification", "Your password must contain at least one special character.", "danger");
                return;
            }
            else if (!(/[A-Z]/.test(this.state.password))) {
                this.setState({ loading: false });
                this.showNoti("Notification", "Your password must contain at least one upper case letter.", "danger");
                return;
            }
            
        }

        var today = new Date();
        var birthDate = new Date(this.state.DOB);

        var age = today.getFullYear() - birthDate.getFullYear();

        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        if (age < 18) {
            this.setState({ loading: false });
            this.showNoti("Notification", "Age should be 18+", "danger");
            return;
        }

        this.state.userName = this.state.beneficiaryName;
        this.state.remitterCode = this.state.remitterCode;

        const demoUserProfile = this.state;
        axios.post(global.UserManagement.CompleteProfileAPI, demoUserProfile)
            .then(json => {
                if (json.data.status) {
                    this.setState({ loading: false });
                  
                    this.showNoti("Notification", "Details uploaded successfully. Redirecting you to login page", "success");
                    setTimeout(() => window.location.href = this.state.URL, 2000)
                }
                else {
                    this.setState({ loading: false });
                    this.showNoti("Notification", json.data.message, "danger");
                }
            })
    }


    render() {
        if (this.state.loading) return <Spinner />;
        const { beneficiaryNameErr, DPIDErr, passwordErr, DOBErr } = this.state.formErrors;
        return (
            <div className="container-login100 banner_area">
                <ReactNotification />
                <div className="container box_1620">
                    <div className="formDiv">
                        <div>
                            <h5 style={{ textAlign: 'center', color: 'black' }}>{this.state.Title}</h5>
                        </div>
                        <div className="m-t-20 m-b-20">
                            <Row>
                                <Col md={6}>

                                    <div className="wrap-input100 disabled">
                                        <label htmlFor="beneficiaryName" className="login-label label_color">Beneficiary</label>
                                        <input type="text" name="beneficiaryName"
                                            value={this.state.beneficiaryName}
                                            className="input100"
                                            onChange={this.handleChange}
                                            placeholder="Beneficiary Name"
                                            disabled
                                        />
                                    </div>
                                </Col>
                                <Col md={6}>
                                    
                                    <div className="wrap-input100 disabled">
                                        <label htmlFor="remitterName" className="login-label label_color">Remitter</label>
                                        <input type="text" name="remitterName"
                                            value={this.state.remitterName}
                                            className="input100"
                                            onChange={this.handleFormValidation}
                                            placeholder="PAN"
                                            disabled
                                        />
                                    </div>
                                </Col>

                                <Col md={6} className="m-t-20">
                                    
                                    <div className="wrap-input100 disabled">
                                        <label htmlFor="PAN" className="login-label label_color">PAN</label>
                                        <input type="text" name="PAN"
                                            value={this.state.PAN}
                                            className="input100"
                                            onChange={this.handlePANChange}
                                            placeholder="PAN"
                                            disabled
                                        />
                                    </div>
                                </Col>

                                
                                <Col md={6} className="m-t-20">
                                    
                                    <div className={this.state.IsDOBEnable == true ? "wrap-input100 disabled" : "wrap-input100 "} >
                                        <label htmlFor="DOB" className="login-label label_color required-field">Date of Birth</label>
                                        <input type="date" name="DOB"
                                            value={this.state.DOB}
                                            className="input100"
                                            onChange={this.handleChange}
                                            placeholder="DD-MMM-YYYY"
                                            max={this.state.currentDate}
                                            disabled={this.state.IsDOBEnable}
                                        />
                                    </div>
                                </Col>
                                <Col md={6} className="m-t-20" >
                                    
                                    <div className="wrap-input100">
                                        <label htmlFor="password" className="login-label label_color required-field">Password</label>
                                        <input type="password" name="password"
                                            value={this.state.password}
                                            className="input100"
                                            onChange={this.handleChange}
                                            placeholder="Password"

                                        />
                                    </div>
                                    {passwordErr &&
                                        <div style={{ color: "red", paddingBottom: 10 }}>{passwordErr}</div>
                                    }
                                </Col>
                                <Col md={6} className="m-t-20" >
                                    
                                    <div className="wrap-input100">
                                        <label htmlFor="ConfirmPassword" className="login-label label_color required-field">Confirm Password</label>
                                        <input type="password" name="ConfirmPassword"
                                            value={this.state.ConfirmPassword}
                                            className="input100"
                                            onChange={this.handleChange}
                                            placeholder="Confirm Password"

                                        />
                                    </div>
                                </Col>
                                <div className="row" style={{ color: "red", paddingBottom: 10 }} className="m-l-10">{DOBErr}</div>
                                <div className="row" style={{ color: "red", paddingBottom: 10 }} className="m-l-10">{passwordErr}</div>
                                <div className="row" style={{ color: "red", paddingBottom: 10 }} className="m-l-10">{DPIDErr}</div>
                                <Col md={12} className="m-t-10">
                                    <div className="container-login100-form-btn" >
                                        <button className="login100-form-btn" onClick={this.handleSubmit}>
                                            {this.state.ButtonText} 
                                        </button>
                                    </div>
                                </Col>
                                <Col md={12} className="m-t-20">
                                    <span className="login100-form-title-New">
                                        *Password should at least 8 characters, one digit, one special character & one upper case letter.
                                    </span>
                                </Col>
                            </Row>

                        </div>

                    </div>
                </div>
            </div>

        );
    }


}